/* ---- Shop Pay Installments price-sync helper ----------------- */
document.addEventListener('variant:change', () => {
  if (window.ShopPayInstallments) ShopPayInstallments.update();
});
document.addEventListener('shopify:section:load', () => {
  if (window.ShopPayInstallments) ShopPayInstallments.update();
});